import { ReactElement, Suspense } from 'react';
import { FieldsProps } from './types';

import { TextField } from '@ff-it/form';
import { FIELD_MAP } from './Fields';
import { CommonFields } from './CommonFields';
import { AttachmentField } from 'modules/attachments/AttachmentField';
import { RichTextField } from 'components/RichText';
import { Spinner } from '@ff-it/ui';

export function BriefFields(props: FieldsProps): ReactElement {
  const Fields = FIELD_MAP[props.type];
  return (
    <>
      <CommonFields {...props} />
      <Suspense fallback={<Spinner />}>
        <RichTextField
          name="brief.markdown"
          label="Brief"
          testId="brief-field"
          attachments={false}
          references={props.references}
        />
      </Suspense>
      {props.type !== 'SEO' && (
        <TextField
          name="suggested_media"
          label="Suggested media"
          help={props.type === 'CREATIVE' ? 'For which channels materials will be used for' : undefined}
        />
      )}
      {Fields && <Fields />}

      <AttachmentField name="brief_attachments" label="Attachements" />
    </>
  );
}
